<script>
import { defineComponent, ref, reactive } from "@vue/composition-api";
import { CheckRecordServiceProxy } from "@/service-proxies/app-v2/tpm.service-proxies";
import { getImg, getTxt } from "@/utils";
import previewImg from "@/components/PreviewImg/index.vue";
import { cloneDeep } from "lodash";
import { ServiceProxy as ResourceServiceProxy } from '@/service-proxies/app-v2/resource.service-proxies'
const resourceService = new ResourceServiceProxy()

const crsp = new CheckRecordServiceProxy();

export default defineComponent({
  props: ["data"],
  components: {
    previewImg,
  },
  setup(props, { root }) {
    const schema = ref([
      { label: root.$t("accessory" || "附件"), ui: { widget: "image-list" } },
    ]);

    const images = ref([]);
    const currentFiles = ref([]);
    const previewIndex = ref();
    const previewVisible = ref(false);
    const encode = ref("UTF-8");
    const imgList = ref([]);
    const fileSrcs = ref([]);
    const getCurrentFiles = () => {
      imgList.value = [];
      currentFiles.value.map(async (file, index) => {
        let content;

        if (
          file.contentType != "image/jpg" &&
          file.contentType != "image/jpeg" &&
          file.contentType != "image/png" &&
          file.contentType != "image/svg" &&
          file.contentType != "image/gif" &&
          file.contentType != "text/txt" &&
          file.contentType != "text/json" &&
          file.contentType != "application/pdf" &&
          file.contentType != "application/swf" &&
          file.contentType != "image/octet-stream"
        ) {
          file.contentType = "text/txt";
          content = await getTxt(file, encode.value);
        }

        if (file.contentType.indexOf("image") > -1) {
          content = await getImg(file);
        }

        if (file.contentType.indexOf("pdf") > -1) {
          content = await (
            await resourceService.statFileUsingGET(file.objectKey)
          ).data.link;
        }

        let temp = {
          type: file.contentType.substring(0, file.contentType.indexOf("/")),
          content,
        };
        fileSrcs.value[index] = temp;
        fileSrcs.value = cloneDeep(fileSrcs.value);
      });
    };
    async function readImages(id) {
      currentFiles.value = await crsp.checkRecordFileList(id);
      getCurrentFiles();
    }

    function changeEncode(val) {
      encode.value = val;
      getCurrentFiles();
    }

    const fileFormData = reactive({
      galleryVisible: false,
      currentIndex: 0,
    });
    function openPreview(i, arr) {
      this.previewVisible = true;
      this.previewIndex = i;
    }
    function closePreview() {
      this.previewVisible = false;
    }

    readImages(props.data.id);

    return {
      schema,

      images,
      fileFormData,
      openPreview,
      closePreview,
      previewVisible,
      previewIndex,
      imgList,
      getCurrentFiles,
      changeEncode,
      encode,
      currentFiles,
      fileSrcs,
    };
  },
});
</script>

<template>
  <div>
    <ml-form :schema="schema">
      <template #image-list>
        <ul>
          <li v-for="(item, index) in fileSrcs" :key="index">
            <!-- <div class="d-flex" style="justify-content: center; align-items: center; width: 150px; height: 150px;">
              <img
                :src="item"
                style="max-width: 100%; max-height: 100%; cursor: pointer"
                @click="
                  () => {
                    fileFormData.currentIndex = index
                    fileFormData.galleryVisible = true
                  }
                "
              />
            </div> -->
            <div class="img-panel">
              <img
                v-if="item && item.type && item.type === 'image'"
                :src="item.content"
                @click="openPreview(index)"
                style="cursor: pointer"
              />
              <div
                @click="openPreview(index)"
                style="position: absolute;z-index: 9999; width:192px; height: 178px;cursor: pointer"
              ></div>
              <embed
                v-if="item && item.type && item.type === 'application'"
                :src="item.content"
                type="application/pdf"
                style="cursor: pointer"
              />
              <div
                v-if="item && item.type && item.type === 'text'"
                @click="openPreview(index)"
              >
                <textarea
                  class="txt-content"
                  v-model="item.content"
                  style="cursor: pointer; color:#000000;"
                  disabled
                />
              </div>
            </div>
          </li>
        </ul>
      </template>
    </ml-form>
    <!-- <gallery
      :imgs="images"
      :visible="fileFormData.galleryVisible"
      :index="fileFormData.currentIndex"
      @cancel="() => (fileFormData.galleryVisible = false)"
    ></gallery> -->
    <previewImg
      :visible="previewVisible"
      :imgs="fileSrcs"
      :index="previewIndex"
      @cancel="closePreview"
      @changeEncode="changeEncode"
    />
  </div>
</template>
